import type { GroupContext, Property } from '../types/group-scope.type';

export const GROUP_CONTEXT: GroupContext = {
  id: 'sun-intl',
  name: 'Sun International',
  initials: 'SI',
};

export const PROPERTIES: ReadonlyArray<Property> = [
  { id: 'sun-001', name: 'The Maslow Sandton', location: 'Johannesburg', region: 'Africa' },
  { id: 'sun-002', name: 'Table Bay Hotel', location: 'Cape Town', region: 'Africa' },
  { id: 'sun-003', name: 'The Boardwalk', location: 'Gqeberha', region: 'Africa' },
  { id: 'sun-004', name: 'Sun City Resort', location: 'Rustenburg', region: 'Africa' },
  { id: 'sun-005', name: 'Wild Coast Sun', location: 'Port Edward', region: 'Africa' },
  { id: 'sun-006', name: 'The Royal Livingstone', location: 'Livingstone', region: 'Africa' },
  { id: 'sun-007', name: 'Kalahari Sands', location: 'Windhoek', region: 'Africa' },
  { id: 'sun-008', name: 'Federal Palace', location: 'Lagos', region: 'Africa' },
  { id: 'sun-009', name: 'The Carlton', location: 'London', region: 'Europe' },
  { id: 'sun-010', name: 'Hôtel Lumière', location: 'Paris', region: 'Europe' },
  { id: 'sun-011', name: 'Gran Vía Palace', location: 'Madrid', region: 'Europe' },
  { id: 'sun-012', name: 'Canal House', location: 'Amsterdam', region: 'Europe' },
  { id: 'sun-013', name: 'Bellagio Lakeside', location: 'Como', region: 'Europe' },
  { id: 'sun-014', name: 'Marina Bay Towers', location: 'Dubai', region: 'Middle East' },
  { id: 'sun-015', name: 'The Pearl Doha', location: 'Doha', region: 'Middle East' },
  { id: 'sun-016', name: 'Red Sea Riviera', location: 'Jeddah', region: 'Middle East' },
  { id: 'sun-017', name: 'Abu Dhabi Corniche', location: 'Abu Dhabi', region: 'Middle East' },
  { id: 'sun-018', name: 'Orchard Grand', location: 'Singapore', region: 'Asia' },
  { id: 'sun-019', name: 'Bay of Lights', location: 'Hong Kong', region: 'Asia' },
  { id: 'sun-020', name: 'Sakura Garden', location: 'Tokyo', region: 'Asia' },
];
